<style lang="scss" src='./StationDetails.scss' scoped></style>
<template src="./StationDetails.html"></template>

<script>
import { mapMutations, mapState } from "vuex";
import SensorChart from "../../../../sensors/details/chart/SensorChart.vue";
import GwRing from "@/components/gwRing/GwRing.vue";
import TaskDetails from '@/views/task/details/TaskDetails.vue';

export default {
  name: "StationDetails",
  props: {
    station: {
      requiered: false,
    },
    alert: {
      requierd: true,
    },
  },
  data() {
    return {
      ico_measurement: null,
      ringData: null
    };
  },
  components: {
    SensorChart,
    GwRing,
    TaskDetails,
  },
  watch: {},

  computed: {
    ...mapState("sensors", ["showAlertList", "ringsData"]),
  },

  methods: {
    getRssiIcon() {
      // eslint-disable-next-line
      return require(`@/assets/img/sensor/ic_rssi_bad.png`);
    },

    showAlertDetails() {
      this.setShowAlertList(true);
    },

    getThresholdViolation(alert) {
      const threshold = alert.station.thresholds.find(t => t.alert_type_id === alert.alert_type_id);
      if (threshold) {
        const value = alert.violation === 'READING_HIGH' ? threshold.max : threshold.min;
        return this.G_getMeasurement({ val: value,
                                    uom: alert.alert_type.uom,
                                    addUnit: true, invertUOM: false });
      }

    },

    async setIcoMeasurement() {
      const alertKey = this.consts.AlertType[
        this.alert.alert_type.alert_type_id
      ].key;
      this.ico_measurement = await require(`@/assets/img/alert/${alertKey}_fill.png`);
    },

    ...mapMutations("sensors", ["setShowAlertList"]),
  },

  beforeCreate() {},

  created() {},

  mounted() {
    this.setIcoMeasurement();

    if(this.alert.alert_type_id != 'WS_COMMUNICATION_FAILURE'){

      const threshold = this.alert.station.thresholds.find(t => t.alert_type_id === this.alert.alert_type_id);
      const unitOfMeasurament = this.G_getUOM({
            uom: threshold.alert_type.uom
      });

      const current = this.G_getMeasurement({ val: this.alert.reading, uom: threshold.alert_type.uom });
      const maxTh = threshold.max ? this.G_getMeasurement({ val: threshold.max, uom: threshold.alert_type.uom }): null;
      const maxVal = threshold.alert_type.max ? this.G_getMeasurement({ val: threshold.alert_type.max, uom: threshold.alert_type.uom }): null;
      const minTh = threshold.min ? this.G_getMeasurement({ val: threshold.min, uom: threshold.alert_type.uom }): null;
      const minVal = threshold.alert_type.min ? this.G_getMeasurement({ val: threshold.alert_type.min, uom: threshold.alert_type.uom }): null;

      let data = {
        alert: true,
        currentValue: parseFloat(current),
        key: this.alert.alert_type_id,
        maxThreshold: maxTh,
        maxValue: maxVal,
        minThreshold: minTh,
        minValue: minVal,
        unit: unitOfMeasurament
      }



      this.ringData = data;
    }
  },
};
</script>
